import React, { useState, useEffect } from 'react'
import * as Icons from '@hose/eui-icons'
import { ConsumptionCategoryObject, ConsumptionTypeOptions, ConsumptionCategory } from './types'

export const ConsumptionIcon = (props: { consumptionCategory?: ConsumptionCategory, consumptionType?: string }) => {
    const [item, setItem] = useState<{ icon: keyof typeof Icons, color: string, bgColor: string } | null>(null)

    useEffect(() => {
        if (!props.consumptionCategory) return
        const categoryObj = ConsumptionCategoryObject[props.consumptionCategory]
        const typeObj = categoryObj ? ConsumptionTypeOptions[props.consumptionCategory]?.find((item: any) => item.value === props.consumptionType) : null
        if (typeObj) {
            setItem({
                icon: typeObj.icon,
                color: typeObj.color,
                bgColor: typeObj.bgColor
            })
            return
        }
        if (categoryObj) {
            setItem({
                icon: categoryObj.icon,
                color: categoryObj.color,
                bgColor: categoryObj.bgColor
            })
        }
    }, [props])


    const renderIcon = (icon: keyof typeof Icons, color: string) => {
        if (!icon) return null
        if (React.isValidElement(icon)) return icon
        const Component = Icons[icon as keyof typeof Icons]
        return <Component fontSize={8} color={color} />
    }

    const iconNode = item ? renderIcon(item.icon, item.color) : null
    if (!iconNode) return null

    const iconWrapperStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 14,
        height: 14,
        borderRadius: '50%',
        backgroundColor: item?.bgColor || 'transparent',
        color: item?.color || 'inherit',
        flexShrink: 0
    }

    return <span style={iconWrapperStyle}>{iconNode}</span>
}

export default ConsumptionIcon